import { defineComponent as _defineComponent } from 'vue'
import { computed, nextTick, onUnmounted, reactive, ref, watch } from 'vue';
import { type ContextMenuItem, type ContextMenu, CONTEXT_MENU_ACTION, CONTEXT_MENU_EVENT, CONTEXT_MENU_ID } from '@/angular-app/libs/fabric/fabric.contextmenu';
import type { CanvasEx } from '@/typings/canvas';
import type { Object as FabricObject } from 'fabric/fabric-impl';
import { DatadogEvent, fireDatadogLog } from '@/utils/datadogUtils';
import { useToaster } from '@/composables/toaster';


export default /*#__PURE__*/_defineComponent({
  __name: 'CanvasContextMenu',
  props: {
    canvas: null,
    events: null
  },
  setup(__props: any) {

const props = __props as {
    canvas: CanvasEx;
    events?: Record<CONTEXT_MENU_ACTION, (element?: FabricObject) => void>
};



const menu = reactive({
    x: '0px',
    y: '0px',
    items: [] as ContextMenuItem[],
    element: undefined as FabricObject | undefined
});

const positioned = ref(false);
const menuStyle = computed(() => ({
    top: menu.y,
    left: menu.x,
    visibility: positioned.value ? 'visible' : 'hidden'
}));

const toast = useToaster();
const handleItemClick = (item: ContextMenuItem) => {
    try {
        const callback = item.onClick || props.events?.[item.action!];
        callback?.(menu.element);
    } catch (error) {
        const msg = `Error executing action ${item.label}`
        toast.error(msg);
        console.error(msg, error);
    } finally {
        onMenuClosed();
        fireDatadogLog(`${item.label} - Right Click Menu` as DatadogEvent);
    }

};

/** Margin kept off the viewport edges */
const VIEWPORT_MARGIN_PX = 8;
const menuRef = ref<HTMLElement | null>(null);
/** Anchored at the pointer, flipped back over it when it would overflow the viewport */
const positionMenu = (anchorX: number, anchorY: number) => {
    const el = menuRef.value;
    if (!el) return;

    const { width, height } = el.getBoundingClientRect();
    const left = anchorX + width > window.innerWidth - VIEWPORT_MARGIN_PX ? anchorX - width : anchorX;
    const top = anchorY + height > window.innerHeight - VIEWPORT_MARGIN_PX ? anchorY - height : anchorY;

    menu.x = `${Math.max(left, VIEWPORT_MARGIN_PX)}px`;
    menu.y = `${Math.max(top, VIEWPORT_MARGIN_PX)}px`;
    positioned.value = true;
};

const onMenuOpened = (event: ContextMenu) => {
    positioned.value = false;
    menu.items = [...event.items];
    menu.element = event.selectedElement;
    // The size is only known once the items have rendered, and the overflow flip depends on it
    nextTick(() => positionMenu(event.x, event.y));
};

const onMenuClosed = () => {
    menu.items = [];
};

watch(
    () => props.canvas,
    (canvas) => {
        if (!canvas) return;
        props.canvas.on(CONTEXT_MENU_EVENT.SHOW, onMenuOpened);
        props.canvas.on(CONTEXT_MENU_EVENT.HIDE, onMenuClosed);
    },
    { immediate: true }
);

onUnmounted(() => {
    props.canvas.off(CONTEXT_MENU_EVENT.SHOW, onMenuOpened);
    props.canvas.off(CONTEXT_MENU_EVENT.HIDE, onMenuClosed);
});

return { __sfc: true,props, menu, positioned, menuStyle, toast, handleItemClick, VIEWPORT_MARGIN_PX, menuRef, positionMenu, onMenuOpened, onMenuClosed, CONTEXT_MENU_ID }
}

})